<script setup>
import ReportTable from '@frontJs/components/tables/projectManagement/customers/ReportTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h, onMounted, ref } from 'vue';

const loading = ref(true);

const data = ref({
    withReport: 0,
    withoutReport: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.projectManagement.customer.postReportCount'), {
            withReport: true,
        }),
        axios.post(route('front.projectManagement.customer.postReportCount'), {
            withReport: false,
        }),
    ])
        .then((response) => {
            data.value.withReport = response[0].data.count;
            data.value.withoutReport = response[1].data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Rapports - Clients - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Clients - Rapports </PageTitle>

    <TabLayout
        :tabs="{
            withReport: {
                title: 'Clients avec rapport',
                total: data.withReport,
                content: h(ReportTable, { withReport: true }),
            },
            withoutReport: {
                title: 'Clients sans rapport',
                total: data.withoutReport,
                content: h(ReportTable, { withReport: false }),
            },
        }"
        :loading="loading"
    />
</template>
